








































































import Vue from 'vue'
import { GetPaymentInformationResponse } from '@/types/service-response'
import { GET_PROJECT_REPRINT_PAYMENT_INFORMATION } from '@/store/action-types'

interface ComponentData {
  field1: string
  field2: string
  field3: string
  field4: string
  field5: string
  field6: string
  field7: string
  field8: string
  field9: string
  field10: string
  field11: string
  field12: string
  field13: string
  field14: string
  field15: string
}

export default Vue.extend({
  name: 'ProjectReprintQR',

  components: {

  },

  props: {
    belegId: Number
  },

  data (): ComponentData {
    return {
      field1: '',
      field2: '',
      field3: '',
      field4: '',
      field5: '',
      field6: '',
      field7: '',
      field8: '',
      field9: '',
      field10: '',
      field11: '',
      field12: '',
      field13: '',
      field14: '',
      field15: '',
    }
  },

  watch: {
    belegId (newVal: number): void {
      if (newVal && newVal !== 0) {
        this.fetchData()
      } else {
        this.field1 = ''
        this.field2 = ''
        this.field3 = ''
        this.field4 = ''
        this.field5 = ''
        this.field6 = ''
        this.field7 = ''
        this.field8 = ''
        this.field9 = ''
        this.field10 = ''
        this.field11 = ''
        this.field12 = ''
        this.field13 = ''
        this.field14 = ''
        this.field15 = ''
      }
    }
  },

  computed: {

  },

  methods: {
    async fetchData (): Promise<void> {
      const response: GetPaymentInformationResponse = await this.$store.dispatch(GET_PROJECT_REPRINT_PAYMENT_INFORMATION,  this.belegId)
      if(!response.IsError && response.Data) {
        this.field1 = response.Data.QRType ? response.Data.QRType : ''
        this.field2 = response.Data.QRVersion ? response.Data.QRVersion : ''
        this.field3 = response.Data.CodingType ? response.Data.CodingType : ''
        this.field4 = response.Data.ZahlungsempfaengerGenAdresse ? response.Data.ZahlungsempfaengerGenAdresse : ''
        this.field5 = response.Data.IBAN ? response.Data.IBAN : ''
        this.field6 = response.Data.EndZahlungsempfaengerGenAdresse ? response.Data.EndZahlungsempfaengerGenAdresse : ''
        this.field7 = response.Data.ZahlungspflichtigerGenAdresse ? response.Data.ZahlungspflichtigerGenAdresse : ''
        this.field8 = response.Data.Betrag ? response.Data.Betrag : ''
        this.field9 = response.Data.WaehrungCode ? response.Data.WaehrungCode : ''
        this.field10 = response.Data.ZahlbarBis ? response.Data.ZahlbarBis : ''
        this.field11 = response.Data.Referenztyp ? response.Data.Referenztyp : ''
        this.field12 = response.Data.Referenznummer ? response.Data.Referenznummer : ''
        this.field13 = response.Data.ZusaetzlicheInformationen ? response.Data.ZusaetzlicheInformationen : ''
        this.field14 = response.Data.AlternativeVerfahren1 ? response.Data.AlternativeVerfahren1 : ''
        this.field15 = response.Data.AlternativeVerfahren2 ? response.Data.AlternativeVerfahren2 : ''
      }
    }
  },

  mounted () {
    if(this.belegId) {
      this.fetchData()
    }
  }
})
